var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopyInversed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 2.5,
    stroke: "#FBAB1C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.7143 11.6777H10.6071C9.71954 11.6777 9 12.3973 9 13.2849V22.392C9 23.2796 9.71954 23.9991 10.6071 23.9991H19.7143C20.6019 23.9991 21.3214 23.2796 21.3214 22.392V13.2849C21.3214 12.3973 20.6019 11.6777 19.7143 11.6777Z",
    fill: "#FBAB1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3945 9H12.7517C11.8689 8.99997 11.1513 9.71204 11.1445 10.5948C11.1445 10.5991 11.1445 10.6028 11.1445 10.6071H19.716C21.1946 10.6089 22.3928 11.8071 22.3945 13.2857V21.8571C22.3988 21.8571 22.4026 21.8571 22.4069 21.8571C23.2897 21.8504 24.0017 21.1328 24.0017 20.25V10.6071C24.0017 9.71954 23.2821 9 22.3945 9Z",
    fill: "#FBAB1C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyInversed);
export default __webpack_public_path__ + "static/media/icon-copy-inversed.88f8854cf608e4e024a706c50e8b6be8.svg";
export { ForwardRef as ReactComponent };